import TreeItem from './treeItem.vue';
import dateFormat from 'dateformat';

export default {
    methods: {
        onSelect({ /* root, node, */ data }) {
            this.currentRow = data;
            if (data.plan) {
                if (!data.checked) {
                    this.showPlan(data);
                }
            } else {
                if (!data.expand) {
                    this.$set(data, 'expand', true);
                } else {
                    this.$set(data, 'expand', false);
                }
            }
        },
        //方案列表鼠标悬浮显示详细信息
        async onMouseOver(evt, data) {
            this.planDetail = false;
            if (
                evt.fromElement.getBoundingClientRect() &&
                this.$refs.thematicDrag.$el.getBoundingClientRect()
            ) {
                // this.planX = evt.fromElement.getBoundingClientRect().right + 35
                this.planX =
                    this.$refs.thematicDrag.$el.getBoundingClientRect().right +
                    5;
                this.planY = evt.fromElement.getBoundingClientRect().top - 70;
                this.detailTitle = data.title;
                const planInfo = await this.getPlanInfo(data.planId);
                this.planDescription = planInfo.configcont.basic.description;
                if (planInfo.configcont.basic.date === '') {
                    this.planDate = planInfo.configcont.basic.date;
                } else {
                    this.planDate = dateFormat(
                        new Date(planInfo.configcont.basic.date),
                        ' yyyy-mm'
                    );
                }
                this.planSource = planInfo.configcont.basic.source;
                this.planDetail = true;
            }
        },
        onMouseOut() {
            this.planDetail = false;
        },
        // render
        treeRender(h, { root, node, data }) {
            const onSelect = evt => {
                this.onSelect({ root, node, data }, evt);
            };
            const onMouseOver = evt => {
                this.onMouseOver(evt, data);
            };
            const onMouseOut = (/* evt */) => {
                this.onMouseOut();
            };
            return (
                <TreeItem
                    root={root}
                    node={node}
                    data={data}
                    nativeOnClick={onSelect}
                    nativeOnMouseover={onMouseOver}
                    nativeOnMouseout={onMouseOut}
                />
            );
        },
        createTree(data, pid) {
            const list = [];
            const _this = this;
            data.map(function (item) {
                if (item.parentId === pid) {
                    item.children = _this.createTree(data, item.id);
                    const { name, id, planid, /* parentId, */ children } = item;
                    if (item.istree) {
                        if (item.children.length === 0) {
                            list.push({
                                title: name,
                                treeId: id,
                                expand: false,
                                disableCheckbox: true,
                                children: children,
                            });
                        } else {
                            list.push({
                                title: name,
                                treeId: id,
                                expand: false,
                                disableCheckbox: true,
                                children: children,
                            });
                        }
                    } else {
                        list.push({
                            title: name,
                            planId: planid,
                            plan: {},
                            expand: false,
                            children: children,
                        });
                    }
                }
            });
            return list;
        },
    },
};
